module.exports = __webpack_public_path__ + "files/3b3cbaef084e27f7fa05d9fe31afb287.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-300.woff
 ** module id = 944
 ** module chunks = 0
 **/